<div class="New-tags">
  <div class="close-model">
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModel()"></button>
  </div>
  <div class="analyse-tag mx-3 mx-md-4 my-3 my-md-4">
    <div class="row">
      <div class="col-8">
        <h3 class="ft-22-18 my-4 my-md-1 mt-2">New tag</h3>
      </div>
    </div>
    <div class="d-none d-md-block"><br></div>
    <div class="row">
      <div class="col-4 col-md-3">
        <div class="color-input-container cursor-pointer" (click)="showAllColors()">
          <div class="alert color cursor-pointer" [ngClass]="'bg-' + newColor">
          </div>
          <span class="px-2 pt-1 text-secondary ft-12 cursor-pointer">Color</span>
          @if (showColors) {
            <div >
              <ul class="dropdown">
                @for (colorList of bgColor; track colorList) {
                  <li class="flex-color alert all-color-li" [ngClass]="'bg-' + colorList" (click)="selectcolorList(colorList)">
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
      <div class="col-8 col-md-9">
        <div class="form-group">
          <input type="text" maxlength="20" class="form-control py-3" oninput="this.value = this.value.replace(/[^A-Za-z0-9\s-]/g, '')" [(ngModel)]="inputTagName"    placeholder="Tag">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-end">
        <button class="btn btn-primary px-4 ft-14 mb-2 mt-2 save-tag" (click)="createTags()">Save</button>
      </div>
    </div>
  </div>
</div>

<ngx-loading [show]="loading">Loading...</ngx-loading>